// extracted by mini-css-extract-plugin
export default {"hero_container":"hero_hero_container__j9Ew-","video":"hero_video__OvVzY","hero_data_container":"hero_hero_data_container__sMWPr"};